import { AiPointerButton, type AutoOpen } from './AiPointerButton';
import type { PointerHelpSource } from './types';

export function HelpTitle({
  text,
  help,
  autoOpen,
}: {
  text: string;
  help: PointerHelpSource;
  autoOpen?: AutoOpen;
}) {
  const lastSpace = text.lastIndexOf(' ');
  const head = text.slice(0, lastSpace + 1);
  const tail = text.slice(lastSpace + 1);
  return (
    <span>
      {head}
      <span style={{ whiteSpace: 'nowrap' }}>
        {tail}
        <AiPointerButton inline help={help} autoOpen={autoOpen} />
      </span>
    </span>
  );
}
